import { Component, EventEmitter, OnDestroy, Output, ViewChild, effect, input } from '@angular/core';
import {
  QaiButtonComponent,
  QaiDialogComponent,
  QaiFloatingDirective,
  QaiIconComponent,
  QaiTooltipComponent,
} from '@qai/ui';
import { TranslocoModule } from '@jsverse/transloco';
import { CallStoreService } from 'src/app/pages/learner/call/library/call-store/call-store.service';
import { isIosDevice } from 'src/app/utils/device/device.util';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
  selector: 'app-screenshare-unsupported-modal',
  standalone: true,
  imports: [
    QaiDialogComponent,
    QaiButtonComponent,
    QaiIconComponent,
    QaiTooltipComponent,
    QaiFloatingDirective,
    TranslocoModule,
  ],
  templateUrl: './screenshare-unsupported-modal.component.html',
  styleUrls: ['./screenshare-unsupported-modal.component.scss'],
})
export class ScreenshareUnsupportedModalComponent implements OnDestroy {
  isVisible = input(false);
  callName = input('');

  @Output() closed = new EventEmitter<void>();

  @ViewChild('dialog') dialogRef: QaiDialogComponent | undefined;
  @ViewChild(QaiFloatingDirective) goToAppTooltip: QaiFloatingDirective | undefined;

  private goToAppTooltipHideTimeout: ReturnType<typeof setTimeout> | undefined;

  constructor(
    private callStore: CallStoreService,
    private translationService: TranslationService
  ) {
    this.translationService.loadScopedTranslation('call');

    effect(() => {
      if (this.isVisible()) {
        this.dialogRef?.showModal();
        this.callStore.registerModalOpen();
        queueMicrotask(() => {
          const dialogEl = this.dialogRef?.elementRef?.nativeElement;
          if (dialogEl?.contains(document.activeElement)) {
            (document.activeElement as HTMLElement)?.blur();
          }
        });
      } else {
        this.dialogRef?.close();
        this.callStore.registerModalClosed();
      }
    });
  }

  get messageKey(): string {
    return isIosDevice()
      ? 'SCREENSHARE_UNSUPPORTED_MESSAGE_APP'
      : 'SCREENSHARE_UNSUPPORTED_MESSAGE_DESKTOP';
  }

  onClose(): void {
    this.closed.emit();
  }

  onGoToApp(): void {}

  scheduleGoToAppTooltipAutoHide(): void {
    clearTimeout(this.goToAppTooltipHideTimeout);
    this.goToAppTooltipHideTimeout = setTimeout(() => {
      this.goToAppTooltip?.hideFloatingElement();
    }, 2000);
  }

  ngOnDestroy(): void {
    clearTimeout(this.goToAppTooltipHideTimeout);
  }
}
